import { useMatchedGuestProfilesById } from '../queries';
import { useNextMatchedGuestProfiles } from '../queries/useNextMatchedGuestProfiles';
import { MergeMode } from '../types';

interface UseMatchedProfilesParams {
    guestProfileIds: string[];
    mergeMode: MergeMode;
    previousMatchId?: string;
}

export const useMatchedProfiles = ({ guestProfileIds, mergeMode, previousMatchId }: UseMatchedProfilesParams) => {
    const { data: queueProfiles, isFetching: queueLoading } = useNextMatchedGuestProfiles(
        mergeMode === MergeMode.Queue,
        previousMatchId || null
    );

    const { data: singleProfiles, isFetching: singleLoading } = useMatchedGuestProfilesById(
        guestProfileIds,
        mergeMode === MergeMode.Single
    );

    const profiles = mergeMode === MergeMode.Queue ? queueProfiles : singleProfiles;
    const loading = queueLoading || singleLoading;

    return {
        profiles,
        loading,
    };
};
